import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { motion } from 'framer-motion';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './ListeningCarousel.css';

// Front-end fallback tracks
const fallbackTracks = [
  {
    name: 'Domesticated Animanls',
    artists: 'Queens of the Stone Age',
    image: '/fallback/villains.jpeg',
    url: 'https://open.spotify.com/track/61mac2K20BFVXltcnkWQWv?si=ed30de4d6bf44a89',
  },
  {
    name: 'Star Chasing',
    artists: 'Buckethead',
    image: '/fallback/starchase.jpeg',
    url: 'https://open.spotify.com/track/6dYuHdVvl994oauNYS0jMD?si=17a3a3f2745e4372',
  },
  {
    name: 'This Fire',
    artists: "Franz Ferdinand",
    image: '/fallback/thisfire.jpeg',
    url: 'https://open.spotify.com/track/3Obu3jvFSfgLF3pSbi64Vj?si=1d735455f53a482c'
  },
  {
    name: "Ain't No Sunshine",
    artists: "The Equatics",
    image: "/fallback/sunshine.jpg",
    url: 'https://open.spotify.com/track/2dcFp5BKSHTbzoyJd0MdRk?si=2d7bb4b4d2d144a9'
  }
  // add more fallback entries as desired
];

export default function ListeningCarousel() {
  const [tracks, setTracks] = useState([]);

  useEffect(() => {
    fetch('/api/spotify-playlist')
      .then(res => res.json())
      .then(data => setTracks(data.length ? data : fallbackTracks))
      .catch(err => {
        console.error('Spotify fetch error:', err);
        setTracks(fallbackTracks);
      });
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <section className="listening-carousel">
      <h2>What I’m Listening To</h2>
      <Slider {...settings}>
        {tracks.map(t => (
          <motion.div
            key={t.url}
            className="track-card"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            transition={{ duration: 0.3 }}
          >
            <a href={t.url} target="_blank" rel="noopener noreferrer">
              <img src={t.image} alt={t.name} />
              <div className="track-info">
                <strong>{t.name}</strong>
                <h1></h1>
                <span>{t.artists}</span>
              </div>
            </a>
          </motion.div>
        ))}
      </Slider>
    </section>
  );
}
